// The §5.1 event kinds in the Events tab's OWN words — one vocabulary per fact
// (§4 row 2's review resolution), keyed exhaustively over the contract union so
// a twelfth kind fails typecheck in EVERY office consumer rather than silently
// printing its wire token (which is exactly what the conflicts queue did for
// all eleven until task #96; the floor tray keeps the same guard on its side).
// Shared here because two screens render the same fact: the Events tab and the
// S7 conflicts queue must never drift apart in wording.

import type { OperationEventType } from "../hooks/production-queries";

const EVENT_KIND_KEYS = {
  op_started: "production.detail.events.kind.op_started",
  op_paused: "production.detail.events.kind.op_paused",
  op_resumed: "production.detail.events.kind.op_resumed",
  op_completed: "production.detail.events.kind.op_completed",
  qty_reported: "production.detail.events.kind.qty_reported",
  material_issued: "production.detail.events.kind.material_issued",
  downtime_started: "production.detail.events.kind.downtime_started",
  downtime_ended: "production.detail.events.kind.downtime_ended",
  calibration_recorded: "production.detail.events.kind.calibration_recorded",
  serial_lot_captured: "production.detail.events.kind.serial_lot_captured",
  defect_handoff_flagged: "production.detail.events.kind.defect_handoff_flagged",
} satisfies Record<OperationEventType, string>;

/** The i18n key for a kind, or undefined for a kind this build does not know
 * (bytes written by an older/newer build) — the caller renders the raw name
 * then: a fact rendered oddly beats a fact hidden. */
export function eventKindKeyOf(kind: string): string | undefined {
  return (EVENT_KIND_KEYS as Record<string, string | undefined>)[kind];
}
